import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";

/**
 * SES-001 (CON-010): resuelve los contextos del usuario por UID.
 * @param {Object} params - { requestedApp?, activeUnitId? }
 */
export const getUserContexts = async (params = {}) => {
  try {
    const fn = httpsCallable(functions, "getUserContextsV3");
    const result = await fn(params);
    return result.data;
  } catch (error) {
    console.error("Error obteniendo contextos del usuario:", error);
    throw error;
  }
};

/**
 * SES-005 (CON-011): sesión específica de reventa.
 */
export const getResellerSession = async () => {
  try {
    const fn = httpsCallable(functions, "getResellerSessionV3");
    const result = await fn();
    return result.data;
  } catch (error) {
    console.error("Error obteniendo sesión de reventa:", error);
    throw error;
  }
};
